import { FunctionComponent } from "react";
import PapyrusPage from "../../components/PapyrusPage/PapyrusPage";
import styles from "./Error.module.css";
import { Title } from "@fyrstain/fhir-front-library";
import i18n from "i18next";
 
const Error: FunctionComponent = () => {
 
    return <PapyrusPage loading={false} needsLogin={false} >
        <div className={`d-flex align-items-center justify-content-center gap-5 ${styles.mainErrorContainer}`}>
            <img
                className={styles.imageIcon}
                src={(process.env.PUBLIC_URL ?? "") + "/assets/oops.png"}
                alt={i18n.t("accessibility.errorimage")}
            />
            <Title level={1} prefix={i18n.t('title.error.oops')} content={i18n.t('title.error.problem')} />
        </div>
    </PapyrusPage>
};
 
export default Error;
